import UserMenu from '../../../../../components/stories/organisms/top-navigation/components/user-menu'
import { useHistory } from 'react-router-dom'
import { useAuthStore } from '../../../../../zustand/authentication/use-auth-store'
import { getUser } from '../../../../../react-query/authentication/query/use-me-query'
import { DateTime } from 'luxon'
import UserLicense from '../components/user-license'
import { useGetSubscriptionsQuery } from '../../../../../react-query/authentication/query/use-subscription-query'
import { useGetProfilePictureQuery } from '../../../../../react-query/user-settings/query/use-get-user-profile-picture-query'
import { trackFirebaseEvent } from '../../../../../firebase/firebase-analytics'

const Users = () => {
  const { push } = useHistory()
  const { logout } = useAuthStore()
  const user = getUser()
  const { data: subscriptionData, isLoading } = useGetSubscriptionsQuery()
  const { data: currentUserProfilePicture } = useGetProfilePictureQuery()

  const handleNavigateUserSettings = () => {
    trackFirebaseEvent('user_settings_open', {
      source: 'user_menu'
    })

    push('/userSettings')
  }

  const handleLogout = () => {
    trackFirebaseEvent('user_menu_logout', {
      source: 'user_menu'
    })

    logout()
  }

  const versionNumber = import.meta.env.VITE_REACT_APP_VERSION || '00'
  const targetEnv = import.meta.env.VITE_TARGET_ENV
  const isProduction = !targetEnv || targetEnv === 'production'
  const appVersion = `${versionNumber}${
    isProduction ? '' : `-${targetEnv.substring(0, 2)}`
  }`

  const hasUntilDate =
    subscriptionData?.organisationSubscription?.runtime?.mode === 'EXPIRES'

  const endDate = hasUntilDate
    ? DateTime.fromISO(
        subscriptionData?.organisationSubscription?.runtime?.end
      ).endOf('day')
    : null

  const isExpired = endDate?.isValid ? DateTime.now() > endDate : false

  return (
    <UserMenu
      key="user-menu"
      userData={{
        name: `${user?.firstName} ${user?.lastName}`
      }}
      profilePicture={currentUserProfilePicture}
      onClickUserSettings={handleNavigateUserSettings}
      onClickLogout={handleLogout}
      appVersion={appVersion}
      isExpired={isExpired}
    >
      <UserLicense
        subscriptionData={subscriptionData}
        isExpired={isExpired}
        isLoading={isLoading}
        endDate={endDate}
      />
    </UserMenu>
  )
}

export default Users
